import { SafeUrl } from '@angular/platform-browser';
import { FormContainerComponent } from 'nm-socle-application/app/shared/components/form-container/form-container.component';
import cloneDeep from 'lodash/cloneDeep';

export class CustomerConfig {
    // TODO : plus tard configurable par le client
    public backgroundImage:string = './assets/img/logo-application-520px.png';
    public pageUrl:SafeUrl;
    public styles:any = {};
    public seo:any;

    public homePage:CustomerTemplate;

    constructor(fields?: Partial<CustomerConfig>) {
        if (fields) {
            Object.assign(this, fields);
        }

        if(this.homePage == undefined) {
            this.homePage = new CustomerTemplate();
        }
    }
}

export class CustomerTemplate {
    public static readonly TEMPLATE_HOME_PAGE:string = 'homePage';

    public templateType:string = CustomerTemplate.TEMPLATE_HOME_PAGE;
    public hasSide:boolean = false;
    public showProgress:boolean = true;
    public states: CustomerTemplateState[] = [];
    public defaultState:string = 'login';
    public footer: string;
    public externalStyles:ExternalStyles[] = [];
    public positionSmall:string = "center";
    public showOverlay:boolean = true;

    protected _propList:string[] = ['icon', 'iconPosition', 'image', 'type', "btnLabel", "btnTooltip", "btnIcon", "btnAction", "size", "title", "desc", 'misc'];
    protected _partList:string[] = ['main', 'leftSide', 'rightSide'];

    protected _dependencies:any = {
        'login': ['loginReconnect', 'changeMail', 'changePassword', 'loginPassLost'],
        'loginPassLost': ['loginPassLostResult'],
    }

    constructor(fields?: Partial<CustomerTemplate>) {
        if (fields) {
            Object.assign(this, fields);

            this.states = [];
            if(fields.states) {
                for(let val of fields.states) {
                    this.addUpdateElem(val);
                }
            }

            if(this.positionSmall == undefined) {
                this.positionSmall = 'center';
            }
        }
    }

    public addUpdateElem(rawDatas:any|CustomerTemplateState) {
        let curTplState:CustomerTemplateState;
        let existTplState:CustomerTemplateState = this._getState(rawDatas.name);

        if(existTplState != undefined && rawDatas != undefined) {
            curTplState = this.customizeModel(existTplState, rawDatas);

            let index:number|string = this._getStateIndex(rawDatas.name);

            this.states[index] = curTplState;
        } else {
            curTplState = new CustomerTemplateState(rawDatas)
            this.states.push(curTplState);
        }

        if(this._dependencies[curTplState.name] != undefined) {
            for(let depName of this._dependencies[curTplState.name]) {
                this.addUpdateElem(ModelState[depName]);
            }
        }
    }

    public globalCustomize(rawDatas:any) {
        let props:string[] = ['templateType', 'showProgress', 'hasSide', 'defaultState', 'footer', 'positionSmall', 'showOverlay'];

        for(let curProp of props) {
            if(rawDatas[curProp] != undefined) {
                this[curProp] = rawDatas[curProp];
            }
        }

        if(rawDatas.states != undefined) {
            for(let curState of rawDatas.states) {
                this.addUpdateElem(curState);
            }
        }

        if(rawDatas.externalStyles != undefined) {
            for(let curExtStyle of rawDatas.externalStyles) {
                this.externalStyles.push(curExtStyle);
            }
        }
    }

    protected _getState(name:string):CustomerTemplateState {
        let elem:CustomerTemplateState;

        for(let curState of this.states) {
            if(curState.name == name) {
                elem = curState;
                break;
            }
        }

        return elem;
    }

    protected _getStateIndex(name:string):number|string {
        let index:number|string;

        for(let i in this.states) {
            if(this.states[i].name == name) {
                index = i;
                break;
            }
        }

        return index;
    }

    // TODO : refactor with recursivity
    protected customizeModel(model: CustomerTemplateState, curTplState: CustomerTemplateState|any):CustomerTemplateState {
        let customizedModel:CustomerTemplateState = cloneDeep(model);

        for(let part of this._partList) {
            if(curTplState[part] != undefined) {
                if(customizedModel[part] == undefined) {
                    customizedModel[part] = curTplState[part];
                } else {
                    for(let prop of this._propList) {
                        if(curTplState[part][prop] != undefined) {
                            customizedModel[part][prop] = curTplState[part][prop];
                        }
                    }
                }
            }
        }

        for(let prop of this._propList) {
            if(curTplState[prop] != undefined) {
                customizedModel[prop] = curTplState[prop];
            }
        }

        return customizedModel;
    }
}

export class CustomerTemplateState {
    public name:string;

    public main:CustomState;
    public leftSide:CustomState;
    public rightSide:CustomState;

    public btnLabel:string;
    public btnTooltip:string;
    public btnIcon:string;
    public btnAction: CustomStateAction = new CustomStateAction();

    constructor(fields?: Partial<CustomerTemplateState>) {
        if (fields) {
            Object.assign(this, fields);

            this.main = new CustomState(fields.main);
            this.leftSide = new CustomState(fields.leftSide);
            this.rightSide = new CustomState(fields.rightSide);
            this.btnAction = new CustomStateAction(fields.btnAction);
        }
    }
}

export class CustomState {
    public static readonly SIZE_XS:string = 'size-xs';
    public static readonly SIZE_S:string = 'size-s';
    public static readonly SIZE_M:string = 'size-m';
    public static readonly SIZE_L:string = 'size-l';
    public static readonly SIZE_XL:string = 'size-xl';

    public type:string;
    public icon:string;
    public iconPosition:string = FormContainerComponent.ICON_TOP;
    public title:string;
    public desc:string;
    public size:string = CustomState.SIZE_M;

    public btnLabel:string;
    public btnTooltip:string;
    public btnIcon:string;
    public btnAction: CustomStateAction = new CustomStateAction();
    public misc:StateMiscArgument[] = [];

    constructor(fields?: Partial<CustomState>) {
        if (fields) {
            Object.assign(this, fields);

            this.btnAction = new CustomStateAction(fields.btnAction);

            if(fields.misc) {
                this.misc = [];

                for(let curArg of fields.misc) {
                    this.misc.push(new StateMiscArgument(curArg));
                }
            }
        }
    }

    public getMisc(name:string):StateMiscArgument {
        let m:StateMiscArgument;

        for(let curMisc of this.misc) {
            if(curMisc.name == name) {
                m = curMisc;

                break;
            }
        }

        return m;
    }
}

export class CustomStateAction {
    public type:string;
    public params:string[] = [];

    constructor(fields?: Partial<CustomStateAction>) {
        if (fields) {
            Object.assign(this, fields);
        }
    }
}

export class ExternalStyles {
    public id:string;
    public url:string;

    constructor(fields?: Partial<ExternalStyles>) {
        if (fields) {
            Object.assign(this, fields);
        }
    }
}

export class StateMiscArgument {
    public name: string;
    public value:any;

    constructor(fields?: Partial<StateMiscArgument>) {
        if (fields) {
            Object.assign(this, fields);
        }
    }
}





// -- template states

export class ModelState {
    public static readonly login:CustomerTemplateState = new CustomerTemplateState({
        "name":"login",
        "main": new CustomState({
            "type":"LoginForm",
            "icon":"fa-user",
            "iconPosition": FormContainerComponent.ICON_TOP,
            "title":"login.access"
        })
    });

    public static readonly loginReconnect:CustomerTemplateState = new CustomerTemplateState({
        "name":"loginReconnect",
        "main": new CustomState({
            "type":"LoginReconnect",
            "icon":"fa-user",
            "iconPosition": FormContainerComponent.ICON_TOP,
            "title":"login.timeout.title"
        })
    });

    public static readonly loginPassLost:CustomerTemplateState = new CustomerTemplateState({
        "name":"loginPassLost",
        "main": new CustomState({
            "type":"LoginPassLostForm",
            "icon":"fa-user",
            "iconPosition": FormContainerComponent.ICON_TOP,
            "title":"login.password.forgotten"
        })
    });

    public static readonly loginPassLostResult:CustomerTemplateState = new CustomerTemplateState({
        "name":"loginPassLostResult",
        "main": new CustomState({
            "type":"LoginResult",
            "icon":"fa-user",
            "iconPosition": FormContainerComponent.ICON_TOP,
            "title":"login.password.forgotten",
            "misc": [
                {name:"validSuccessLabel", value:"login.result.password-success"},
                {name:"validPendingLabel", value:"login.result.password-pending"},
                {name:"validFailLabel", value:"login.result.password-fail"},
            ]
        })
    });

    public static readonly changePassword:CustomerTemplateState = new CustomerTemplateState({
        "name":"changePassword",
        "main": new CustomState({
            "type":"PasswordChange",
            "icon":"fa-user",
            "iconPosition": FormContainerComponent.ICON_TOP,
            "title":"login.password-change.alert"
        })
    });

    public static readonly changeMail:CustomerTemplateState = new CustomerTemplateState({
        "name":"changeMail",
        "main": new CustomState({
            "type":"LoginMailForm",
            "icon":"fa-envelope",
            "iconPosition": FormContainerComponent.ICON_TOP,
            "title":"email-change.title",
            "desc":"email-change.inform"
        })
    });


}



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/VyQQATNu/0/groupe-dev/nm17/node_modules/nm-socle-application/app/shared/models/customer-config.ts